<template>
  <QuartzJobList></QuartzJobList>
</template>

<script>
  import QuartzJobList from '../components/QuartzJobList';

  export default {
    name: "JobView",

    components: {
      QuartzJobList
    }
  }
</script>

<style scoped>
</style>
